<template>
  <div class="ma-5">
    <h3>{{ $t("common.hello") }}, {{ authenticatedUser.name }}</h3>
    <v-alert class="mt-5" v-if="!isHavingTarrifplan">
      {{ $t("viewHome.select_the_tariff_to_start_work") }}
      <v-btn elevation="0" :to="'settings/tarrifplans'" color="success">{{
        $t("common.tariff")
      }}</v-btn>
    </v-alert>
    <main-widgets v-if="isHavingTarrifplan"/>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import RightsMixin from "@/mixins/rights";
import draggable from "vuedraggable";
import MainWidgets from "@/components/home/MainWidgets.vue";

export default {
  components: {MainWidgets},
  data: () => ({

  }),
  mixins: [RightsMixin],
  computed: {
    ...mapFields("auth", ["authenticatedUser"]),
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>
